function updateLocationAndCurrencyLink() { 
  var set_shop = '';
  var set_currency = Shopify.currency['active'];
  //document.getElementById('location-select').value = set_shop;
  //$('select#location-select').on('change',function() {
    //$('#change-location').attr("data-shop", this.value);
  //});

  $("#change-location").on('click',function(e) {
    e.preventDefault();
    var set_shop = $(e.target).data('shop');
    document.location.href = 'https://' + set_shop + '?geo=false';
  });
}

$(document).ready(function() {
  updateLocationAndCurrencyLink();
});